import toggle from '@/js/util/symbols/toggle'

export default {
  inject: { toggle },
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    // pass in true to access
    // boolean data in template
    broadcast: {
      type: Boolean,
      default: false,
    },
    buttonName: {
      type: String,
      default: 'menu',
    },
  },
  computed: {
    expanded() {
      return this.toggle.currentButton === this
    },
  },
  created() {
    this.toggle.$emit('create:buttons', this)
  },
  methods: {
    emitButtonClick() {
      this.toggle.$emit('set:current', this)
    },
  },
  render(createNode) {
    const { expanded } = this
    const buttonData = {
      class: { expanded },
      attrs: {
        'aria-expanded': expanded,
      },
      on: {
        click: this.emitButtonClick,
      },
    }

    return createNode(this.tag,
      buttonData,
      !this.broadcast ? this.$slots.default : this.$scopedSlots({ expanded }),
    )
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseToggleButton.js